module.exports = __webpack_public_path__ + "static/media/email@3x.b6d65798.png";